import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";
import { formatApiError } from "../lib/api";
import { Lock } from "lucide-react";

const AdminLogin = () => {
  const { login } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err) || t("admin.login.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050506] flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-14 h-14 border border-[#D4AF37]/40 mb-6">
            <Lock size={18} className="text-[#D4AF37]" />
          </div>
          <h1 className="font-display text-4xl text-white tracking-tight">
            {t("admin.login.title")}
          </h1>
          <p className="text-sm text-white/50 mt-3">{t("admin.login.subtitle")}</p>
        </div>

        <form
          onSubmit={onSubmit}
          className="bg-[#121217] border border-white/10 p-8 space-y-6"
          data-testid="admin-login-form"
        >
          <div>
            <label className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]/80 mb-2 block">
              {t("admin.login.email")}
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="w-full bg-transparent border-b border-white/20 rounded-none px-0 py-3 focus:border-[#D4AF37] focus:outline-none text-white transition-colors"
            />
          </div>
          <div>
            <label className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]/80 mb-2 block">
              {t("admin.login.password")}
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full bg-transparent border-b border-white/20 rounded-none px-0 py-3 focus:border-[#D4AF37] focus:outline-none text-white transition-colors"
            />
          </div>
          {error && (
            <div className="text-xs text-red-400 border border-red-900/40 bg-red-900/10 px-3 py-2" data-testid="admin-login-error">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-[#D4AF37] text-[#0A0A0C] hover:bg-[#C5A059] disabled:opacity-50 px-8 py-4 uppercase tracking-[0.25em] text-xs font-bold transition-colors"
          >
            {loading ? "..." : t("admin.login.submit")}
          </button>
        </form>

        <a href="/" className="block text-center mt-8 text-xs tracking-[0.2em] uppercase text-white/40 hover:text-[#D4AF37] transition-colors">
          ← İstanbul Organizasyon
        </a>
      </div>
    </div>
  );
};

export default AdminLogin;
